import { useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CashPage } from '@/features/cash/cash-page'
import { CASH_TABS, type CashTab } from '@/features/cash/constants'
import { requirePermission } from '@/lib/route-guards'

/** `?tab=` recuerda la pestaña (mi caja / cajas de la agencia). */
const cashSearchSchema = z.object({
  tab: z.enum(CASH_TABS).optional().catch(undefined),
})

/** Caja: apertura, arqueo, movimientos, cierre y supervisión. */
export const Route = createFileRoute('/_app/cash/')({
  beforeLoad: requirePermission({ anyOf: ['cash:operate', 'cash:supervise'] }),
  validateSearch: cashSearchSchema,
  component: CashRoute,
})

function CashRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const onTabChange = useCallback((next: CashTab) => void navigate({ search: { tab: next }, replace: true }), [navigate])
  return <CashPage tab={tab} onTabChange={onTabChange} />
}
